import { render, staticRenderFns } from "./AgenciaImportPage.vue?vue&type=template&id=2530c69e&scoped=true"
import script from "./AgenciaImportPage.vue?vue&type=script&lang=js"
export * from "./AgenciaImportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2530c69e",
  null
  
)

export default component.exports